
import { keyframes, styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import { IconButton } from '@mui/material';
import { IconX } from '@tabler/icons';
import Styles from "../styles/dialog.module.scss"

// Animation keyframes for smooth appearance and disappearance
const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const contentShow = keyframes`
  from {
    opacity: 0;
    transform: scale(0.90) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

// Styled Dialog component with custom animations and dynamic properties
const AnimatedDialog = styled(Dialog)(({ style }) => ({
  '.MuiBackdrop-root': {
    animation: `${overlayShow} 200ms cubic-bezier(0.16, 1, 0.3, 1)`,
  },
  '.MuiPaper-root': {
    animation: `${contentShow} 200ms cubic-bezier(0.16, 1, 0.3, 1)`,

    width: '450px',  // Default width is 450px
    borderRadius: '10px',  // Default border radius is 10px
    overflow: 'visible',

    //dynamic styles
    ...style,

    transition: 'transform 200ms cubic-bezier(0.16, 1, 0.3, 1), opacity 200ms cubic-bezier(0.16, 1, 0.3, 1)',
    '&.MuiDialog-paperExiting': {
      opacity: 0,
      transform: 'scale(0.90) translateY(10px)',
    },
  },
  '.MuiDialog-root': {
    width: '100%',
  }
}));

// Reusable MuiDialog Component
export const MuiDialog = ({
  open,
  handleClose,
  closable = true,
  element,
  style = {},
  title = ''
}) => {
  const handleDialogClose = (event, reason) => {
    if (!closable && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    handleClose();
  };

  return (
    <AnimatedDialog
      open={open}
      onClose={handleDialogClose}
      aria-labelledby="animated-dialog-title"
      TransitionProps={{
        timeout: { enter: 200, exit: 200 },
      }}
      style={style}
    >
      {title &&
        <div className='flex items-center justify-between px-6 py-4 w-full' style={{ borderRadius: '10px 10px 0px 0px' }}>
          <h2 className='text-lg font-semibold'>{title}</h2>
          <button className="mb-1 text-xl" onClick={handleDialogClose}>
            &times;
          </button>
        </div>
      }
      {element}
    </AnimatedDialog>
  );
};


export const DialogBox = ({
  open,
  handleClose,
  closable = true,
  element,
  style = {},
  title = ''
}) => {

  const handleCloseTheDialog = () => {
    window.localStorage.removeItem('showDialog');
    handleClose()
  }

  return (
    <AnimatedDialog
      open={open}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        classes: {
          root: Styles.dialog,
          borderRadius: '5px'
        }
      }}
      onClose={handleCloseTheDialog}
      aria-labelledby="animated-dialog-title"
      TransitionProps={{
        timeout: { enter: 200, exit: 200 },
      }}
      style={{
        overflow: 'auto',
        ...style
      }}
    >
      <div className='flex w-full justify-between items-center'>
        {title &&
          <div>
            {title}
          </div>
        }

        {closable &&
          <IconButton onClick={handleClose}>
            <IconX />
          </IconButton>
        }
      </div>
      {element}
    </AnimatedDialog>
  )
}

